module.exports = __webpack_public_path__ + "static/media/Component 62.968b6ca6.png";